export const props = { viewBox: "0 0 20 20" };
export const innerHTML =
    '<circle stroke="currentColor" stroke-width="2" fill="none" cx="10" cy="10" r="9" />' +
    '<circle fill="currentcolor" cx="10" cy="10" r="5" />';
